import { IAttributeService } from "../../service/formconfiguration/AttributeService";

export default class InvalidateAttributeInteractor {
  private attributeService: IAttributeService;

  constructor(attributeService) {
    this.attributeService = attributeService;
  }

  async execute(qualifierCode: string, attributeCode: string) {
    await this.attributeService.invalidateAttribute(
      qualifierCode,
      attributeCode
    );
  }
}
